import { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';

export class Portal extends Component {
  constructor(props) {
    super(props);
    this.el = document.createElement('div');
  }

  componentDidMount() {
    document.body.appendChild(this.el);
  }

  componentWillUnmount() {
    if (this.el && this.el.parentNode === document.body) {
      document.body.removeChild(this.el);
    }
  }

  render() {
    const { children } = this.props;
    return ReactDOM.createPortal(children, this.el);
  }
}

Portal.propTypes = {
  children: PropTypes.node,
};
